import { ChevronDown } from "lucide-react"; // Icon for the dropdown arrow
import React from "react";
import { Dropdown } from "react-bootstrap";
import Icon from "../../../utils/Icon";
import useSorting from "./useSorting";

const Sorting = ({
  screenWidth,
  selectedTabOption,
  devicesItems,
  rateplansItems,
  articlesItems,
  supportItems,
  isMobile,
  currentPage,
  setCurrentPage,
  updateURL = () => {},
  search = () => {},
  handleShowFilterSection = () => {},
  selectedProductsSorting,
  selectedProductsPerPage,
  setSelectedProductsSorting,
  setSelectedProductsPerPage,
  productSorting,
  categoryNameList,
}) => {
  const {
    productsPerPage,
    handleSortingOptionChange,
    handleProductsPerPageChange,
    labels,
  } = useSorting(
    devicesItems,
    rateplansItems,
    articlesItems,
    supportItems,
    setCurrentPage,
    search,
    updateURL,
    setSelectedProductsSorting,
    setSelectedProductsPerPage,
    selectedProductsSorting,
    selectedProductsPerPage,
  );
  return (
    <>
      <div
        className="dropdown-wrapper"
        style={
          ["articles", "support"].includes(selectedTabOption)
            ? {
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
                width: "100%",
              }
            : {}
        }
      >
        {isMobile &&
          selectedTabOption !== "articles" &&
          selectedTabOption !== "support" &&
          screenWidth < 1200 && (
            <div className="product-count-dropdown">
              <button
                className="filter-button"
                onClick={handleShowFilterSection}
                style={
                  selectedTabOption === "articles" ||
                  selectedTabOption === "support"
                    ? { marginRight: "none" }
                    : {}
                }
              >
                <Icon name="filter" className="filter-button filter-icon" />
                <span className="label p-1">{labels["filters"]}</span>
              </button>
            </div>
          )}

        {/* Sorting & Per page */}
        <div className="dropdown-right">
          <Dropdown>
            <Dropdown.Toggle
              variant="success"
              id="dropdown-basic"
              className="product-count-dropdown"
            >
              {selectedProductsPerPage?.label || productsPerPage[0].label}
              <ChevronDown
                className="custom-chevron"
                style={{ stroke: "#90EE90", marginLeft: "10px" }}
              />
            </Dropdown.Toggle>
            <Dropdown.Menu className={"custom-dropdown-menu"}>
              {productsPerPage.map((option) => (
                <Dropdown.Item
                  className={"product-count-dropdown-items"}
                  key={option.value}
                  onClick={() => handleProductsPerPageChange(option)}
                >
                  {option.label}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
          <Dropdown>
            <Dropdown.Toggle variant="success" id="dropdown-basic" className="product-count-dropdown">
              {selectedProductsSorting}
              <ChevronDown className="custom-chevron" style={{ stroke: "#90EE90", marginLeft: "10px" }}/>
            </Dropdown.Toggle>
            <Dropdown.Menu className="custom-dropdown-menu">
              {Object.entries(productSorting).map(([key,value]) => (
                  <Dropdown.Item
                      className="product-count-dropdown-items"
                      key={key}
                      onClick={() => handleSortingOptionChange(value)}
                  >
                    {value}
                  </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </>
  );
};

export default Sorting;
